module.exports = "<ng-container *ngIf=\"viewState$ | async as viewState\">\r\n  <app-morning-overtime-prompt\r\n    *ngIf=\"viewState.isVisible\"\r\n    [viewState]=\"viewState\"\r\n    (submitAnswer)=\"onSubmitAnswer($event)\">\r\n  </app-morning-overtime-prompt>\r\n</ng-container>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/morning-overtime-readiness/containers/morning-overtime-prompt-container/morning-overtime-prompt-container.component.html
// module id = ../../../../../src/app/content-page/common/morning-overtime-readiness/containers/morning-overtime-prompt-container/morning-overtime-prompt-container.component.html
// module chunks = main